import client from './client';
import type { BillingResp } from '../types';

export const getDashboard = () => client.get('/api/dashboard/regions');
export const getSettings = () => client.get('/api/settings');
export const getBilling = () => client.get<BillingResp>('/api/dashboard/billing');
